package com.sweetlime.bingeamigo

import io.kamel.core.config.KamelConfig
import io.kamel.core.config.takeFrom
import io.kamel.image.config.Default

val customKamelConfig = KamelConfig {
    takeFrom(KamelConfig.Default)

    // Memory cache: number of images to keep in RAM
    imageBitmapCacheSize = 150

    //TODO: HTTP cache via Ktor: handles disk-level caching

}